var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "link text-primary ripple",
      attrs: { to: _vm.clientRoute + "/edit/" + _vm.row.id + "/" }
    },
    [_vm._v("\n      " + _vm._s(_vm.tableValue) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }